import AuthWrapper from '../../components/AuthWrapper';
import ViewItems from '../../components/ViewItems';
import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import Button from '../../components/Button';
import recoverUsernameFunctional from './index.function';
import OTPField from '../../components/OtpField';
import { Formik } from 'formik';
import { otp_schema, otp_validation_schema } from '../../validations_schemas/otp_validation_schemas';
import ErrorText from '../../components/ErrorText';
import ViewReverse from '../../components/ViewReverse';
import Loader from '../../components/Loader';
import images from '../../constants/images';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import { cn } from '../../utils/utils';

const Otp = () => {
  const { TextWeight, isArabic, onPressResetPassword, navigate, getContentKey, authLoading, handleResend, formatTime, seconds } =
    recoverUsernameFunctional();

  return (
    <AuthWrapper>
      <Formik
        validationSchema={otp_validation_schema}
        initialValues={otp_schema}
        validateOnChange={false}
        validateOnMount={false}
        validateOnBlur={false}
        onSubmit={(values) => onPressResetPassword(values)}
      >
        {({ handleSubmit, setFieldValue, values, errors }) => {
          return (
            <ViewItems className={'w-full'}>
              <ReactSVG src={icons.back} className={cn('cursor-pointer', isArabic ? 'rotate-180' : '')} onClick={() => navigate(-1)} />
              <img src={images.textLogo} width={70} className={cn('mt-10', isArabic ? 'self-end' : 'self-start')} />

              <Text text={getContentKey('verification')} weight={TextWeight.semiBold} size={fontSizes.h18} className={'mb-3 mt-10'} />

              <OTPField
                separator={<span>-</span>}
                otpChange={(otp) => {
                  setFieldValue('otp', otp);
                  otp?.length == 4 &&
                    setTimeout(() => {
                      handleSubmit();
                    }, 500);
                }}
              />
              <ErrorText text={errors?.otp} getContentKey={getContentKey} />

              <ViewReverse className={'justify-between w-full my-3'}>
                <ViewReverse className={'items-center gap-1'}>
                  <Text text={getContentKey('code_expire')} color={'text-dark-grey'} size={fontSizes.h14} />
                  <Text text={formatTime()} className={'text-right'} color='text-dark-grey' />
                </ViewReverse>

                <Text
                  text={getContentKey('resend')}
                  color={'text-primary'}
                  className={cn('underline', seconds > 0 ? 'cursor-not-allowed' : 'cursor-pointer')}
                  size={fontSizes.h14}
                  isDisabled={seconds > 0}
                  onClick={handleResend}
                />
              </ViewReverse>

              {authLoading ? (
                <Loader className={'h-8 w-8 mt-6'} />
              ) : (
                <ViewReverse className={'w-full gap-3'}>
                  <Button
                    text={getContentKey('submit')}
                    className={'mt-6 my-2 w-full'}
                    onClick={handleSubmit}
                    loading={authLoading}
                    isDisabled={!(values?.otp?.length > 3)}
                  />
                </ViewReverse>
              )}
            </ViewItems>
          );
        }}
      </Formik>
    </AuthWrapper>
  );
};

export default Otp;
